// Generated code for Big.Process.Web.Enums.CorrespondencePreference.
// Edit _Enum.tst to change the generated output.

export enum CorrespondencePreference {
    unknown = 0,
    byEmail = 1,
    byMail = 2
}
(CorrespondencePreference as any).name = 'CorrespondencePreference';
